import type { SVGProps } from 'react';

const SvgTransactionFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 14.375C7.58581 14.375 7.25 14.0392 7.25 13.625L7.25 4.18652L4.99512 6.44141C4.70227 6.73396 4.22739 6.73399 3.93457 6.44141C3.64168 6.14851 3.64168 5.67278 3.93457 5.37988L7.46973 1.84473C7.76262 1.55183 8.23836 1.55183 8.53125 1.84473L12.0664 5.37988C12.3593 5.67278 12.3593 6.14851 12.0664 6.44141C11.7736 6.73403 11.2987 6.73392 11.0059 6.44141L8.75 4.18555L8.75 13.625C8.75 14.0392 8.41421 14.375 8 14.375Z"
      fill="#AAB3CA"
    />
  </svg>
);

export default SvgTransactionFile;
